import React, { useEffect } from 'react';
import FramePlayer from '../utils/FramePlayer';
import anime from 'animejs';
import lang from '../lang.json';
import { useNavigate } from 'react-router-dom';

const Module6av = (props) => {

    const langue = props.langue;
    const texts = lang.lang[`lang_${langue}`].module6av;

    const navigate = useNavigate();

    return (
        <>
            <div className="background" />

            <video
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '660px',
                    height: '500px',
                    zIndex: 1
                }}
                src={process.env.PUBLIC_URL + "/assets/movies/06a_lubathy.mp4"}
                controls
            />

            {/* textes */}
            <p
                style={{
                    position: 'absolute',
                    left: 10,
                    top: 0,
                    color: 'white',
                    fontSize: '15px',
                    zIndex: 15
                }}
            >{texts.lang1}</p>

            <p
                style={{
                    position: 'absolute',
                    left: 610,
                    top: -40,
                    color: 'white',
                    fontSize: '45px',
                    zIndex: 100,
                    cursor: 'pointer'
                }}
                onClick={() => window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur' + '/menumusic'}
                    //navigate(process.env.PUBLIC_URL + '/menumusic')}
            >X</p>
        </>
    );
}

export default Module6av;
